import React from 'react'
import { useTranslation } from 'react-i18next';
import { Accordion, AccordionItem as Item } from '@szhsin/react-accordion';
import KeyboardArrowDownIcon from 'assets/icons/KeyboardArrowIcon';

function ESGWorkshopTraining() {
  const { t } = useTranslation();

  const AccordionItem = ({ header, order, ...rest }) => {
    return (
      <Item
        {...rest}
        header={({ state: { isEnter } }) => (
          <div className='flex flex-row justify-between gap-6 md:gap-8 xl:gap-10'>
            <div>
              <p className='font-bold text-sm sm:text-lg md:text-2xl xl:text-3xl'>{header}</p>
            </div>
            {header === "Introduction to ESG" && (
              <div className='md:w-[3rem] lg:w-[9rem] xl:w-[4rem]'></div>
            )}
            <div>
              <KeyboardArrowDownIcon
                className={`h-4 md:h-6 xl:h-8 w-4 md:w-6 xl:w-8 ml-auto fill-black transition-transform duration-200 ease-out ${isEnter && "rotate-180"}`}
              />
            </div>
          </div>
        )}
        className={''}
        buttonProps={{
          className: ({ isEnter }) =>
            `w-full sm:p-4 text-left`
        }}
        contentProps={{
          className: "transition-height duration-200 ease-out"
        }}
        panelProps={{ className: "sm:p-4" }}
        initialEntered={true}
      />
    )
  };

  const esg_contents = [
    {
      title: 'Introduction to ESG',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/2538f3da4bc3e9c1bbdbb9033fd7c4a579bf9789291433820f63310f8cd7ab0b77e456f7d642655b6c6e8406c454bb8257e23bb5c51086d102be550a18866613038688dc46ece7decec5e63f93f87f0fa71e7fe9048efe1c6b87c5c1ee4718bb00052570e93ede430f5e421705b1db31bc3c09c536ed486d008e/rez-file-1740640299527.png',
      descriptions: [
        'Understanding Environmental, Social, and Governance (ESG) principles.',
        'The business case for ESG: Risks, opportunities, and regulatory pressures.',
        'ESG trends, ratings, and their impact on industries.'
      ]
    },
    {
      title: 'ESG Frameworks and Regulations: Navigating Compliance',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/e7e7fd3aac239d1394c9e44e2d2190899743706501f1b5512a8e276d337bcf2ab0be3a9686c6b28a5854624a299a1437628bba54e45444d787eb72a937423c0a56f14c7cf74c13be36e653bbdb1cd3a6004a18c87825e1e0298f6f9c10f151eaf4bce1084244fca1b5aa4731473e62ce6f6758c78ad9e1e2d444/file-1740382493038.png',
      descriptions: [
        'Overview of key global ESG frameworks (GRI, SASB, IFRS S1 & S2, TCFD, TNFD, EU CSRD).',
        'Understanding ESG regulations and reporting obligations.',
        'How different industries apply ESG compliance standards.'
      ]
    },
    {
      title: 'ESG Governance: Leadership and Accountability',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/d9dfe70ec661ff75756d8fff555d23e1065c8543ab6e298b376016f67d417e41c1218032afd637d7f835480674e2aa4235793027f7b1e9c0a201870cd262ca92077608063c70f329b14a022fc36ae7a5acf591bacfd7453d2a3b2424d35ec0517cda279e42cb8f25ea7f96892a32d3ae8fec95ac1df076e0bea1/file-1740382525358.png',
      descriptions: [
        'The role of the board and executives in ES strategy.',
        'ESG policies, ethics, and corporate governance best practices.',
        'Stakeholder engagement in governance decision-making.'
      ]
    },
    {
      title: 'ESG Strategy Development: Aligning Business and Sustainability',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/8bf0a3450fba003b5c93de4f90d5ec2fc3957c1de3ba3c788739de1c9cf4a3ce4a19ecb92c9c162d828d410af1fef19cf5b702d46fc14d110870e0b0bd66baccb9ad1568960a20fd034d4bca21e3049ab00a95574d5e7dc2de877e7c7c86fa135fe86cf9a79d227f179d4567837060e112df52b5b3780aeae4ab/file-1740382786946.png',
      descriptions: [
        'Integrating ESG into corporate vision and mission.',
        'Identifying material ESG issues relevant to your organization.',
        'Setting short-term and long-term ESG goals.'
      ]
    },
    {
      title: 'Risk Management in ESG: Identifying and Mitigating Challenges',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/e3c258f6264e7df8c29d739d31fa04cdfeab0485ac7070351c2c9e8edf4c437562234b981ec800776e171191d39c778b2f303a8f579e7160ba750d7c1b83d12565a99a200e959145102b20cad95f93e53f041aaa75d4de3a8e3003e35105bc88ecfa9ff24838b348318c08122a1715f6928c13c51e875aef2781/file-1740382241849.png',
      descriptions: [
        'Understanding ESG risks & Opportunities (climate, social, governance risks).',
        'Scenario planning and risk assessment tools.',
        'Embedding ESG risk into enterprise risk management (ERM).'
      ]
    },
    {
      title: 'ESG in Supply Chain Management: Responsible Sourcing & Operations',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/0a0148f44080b2c9f52559ca1e6801e6a5a8f4702f072f4dc86ae945d827a8fd9402a9df92586e18fb3c769133e3c672501dda6f758b0d3dd74b03428af0714cd91308f10ce1b354193b76fb24bca4ccdf92e3918f0bc802ead05370dff2ad21c1616d9fa6bac12dd7f608a1f6f8bbb34deda183ea72dfc070ba/file-1740382596383.png',
      descriptions: [
        'Evaluating environmental and social risks in the supply chain.',
        'Sustainable procurement and ethical sourcing strategies.',
        'Monitoring and improving supplier ESG performance.'
      ]
    },
    {
      title: 'Environmental Impact & Climate Action: Net-Zero Strategies',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/a193cfc1f8724c858199370ad58fccf155e65acd2a00d82a4bcc9ba94be96e47174b37d73643b48a1e9cfd7fecc75f05c0c0d5c7c07228ea63a24a5500920741779f870c319c7a91020c7be7e5f617c7e37f45a63e070510bee585da214da7192767637e3ae9c2bd8a85a75a58993129163af5e4d53f3308680c/file-1740381759641.png',
      descriptions: [
        'Carbon footprint measurement and reduction strategies.',
        'Energy efficiency, waste management, and water conservation.',
        'Science-based targets (SBTi) and decarbonization pathways.'
      ]
    },
    {
      title: 'Social Responsibility: Diversity, Equity, Inclusion (DEI) and Human Rights',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/2b37833e7d5cf15dd432ab8865be0bbe3025ba0f1175d0d09b9e01e12ee702d73c7e574eec93b1ae0896bb0ae71e41f8f0b608581ba98a7e740ee36b57ae0ff37b79b0e1ae4c4227b8a2a146e52b1493009f2cd81fff5fe78486b916c95fd83a7cb5d6c2e9226eccfe5933aa2ae18254ea9ac30677458b6d689a/file-1740382306928.png',
      descriptions: [
        'Building an inclusive and equitable workplace.',
        'Employee well-being and social impact initiatives.',
        'Human rights due diligence in business operations.'
      ]
    },
    {
      title: 'Sustainable Finance and ESG Investment Trends',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/6305a86f87e0ea527c71057170c3dd4842faf0ad0e9cc17fa2ffd76de9f8fe73d85d860f1d0493047c8079e88302fae102c0c2756fb15da2a419dfd432c5b1a6a28901b337c29c92487e1456a0a1be70f24b7bb78981357461d8ce900ccf70b32f2c618d0c0f7eecd05633855845a89fbb7ec362e989d00b3f5b/file-1740382331626.png',
      descriptions: [
        'The role of ESG in investment decisions and corporate financing.',
        'Green bonds, sustainability-linked loans, and impact investing.',
        'Financial disclosures and ESG performance metrics.'
      ]
    },
    {
      title: 'ESG Data Collection and Performance Metrics',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/29ce7e52700a884b2b7441c46da6a076dbd172d2aa73d98582ac65d157cde9d45caa16c90b42dd8f577b8847b03e3d7e95d8f5c0c4d938b09ee1e62465c9319b0deac6ddbf7cd567dcee7ab8d8b9458332680452b629074f367ff9d1cb56710fcb6f87466dec276e3c2669c380dec4865e7021a6ba771efe9143/file-1740382463723.png',
      descriptions: [
        'Key performance indicators (KPIs) for ESG.',
        'ESG data sources and technology for data management.',
        'Benchmarking ESG performance against industry peers.'
      ]
    },
    {
      title: 'ESG Reporting and Disclosure: Best Practices and Standards',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/b5698443077ffafe2c6907bcba6f89d0aa94cfd5a8d4919e06042afd6c3e1969708ce3800b60a9cfb481a97d6f86fba790c336953b9ee14f9fa1e7da4451740c2a819adbbdc1d1313c6f0e4d51c28418713fc99ab8338172be9e7eea8b57aa5650f64eaed1d9dc312072267b09153609f8608085365ce39924c2/file-1740382690762.png',
      descriptions: [
        'Preparing ESG reports aligned with global frameworks (GRI, SASB, ISSB).',
        'Ensuring transparency, accuracy, and accountability in reporting.',
        'Communicating ESG impact effectively to investors and stakeholders.'
      ]
    },
    {
      title: 'Measuring ESG Impact: Social Return on Investment (SROI) and Other Metrics',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/9c1d60e882c8060a7d0ee7d158a9afa8eae622e6f4953f4b61bdddedf7b4d348f0c493d6f674dafc2b16293cf701c58990307911679936012fdff632a8c7928399e99701e201fc1f9acfc00c0cd0cd1b6ffaeb897611055a9258f8bcbf99b00314931b3c361f0b49084ceaec5e3ea99ec98287072fa75ae1f080/file-1740381985125.png',
      descriptions: [
        'Quantifying social and environmental impact.',
        'Using SROI, LCA (Life Cycle Assessment), and SDG impact tracking.',
        'Case studies on effective ESG impact measurement.'
      ]
    },
    {
      title: 'ESG Audits and Third-Party Verification',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/0a2d2575570c354635e2deb8514dc4d74f50b7410ca52f27e5968b5d01dc14aba43880cc4b3f476d0d3baa5d75583404e1552679532796accdf560734b017472abc7aedc98982b4bc494b6a0a70142287fca4fddc124484a1af7512b3eb735c1f334f96691f8338430110a6f35add29cbd047f8738e2ecc07ec3/rez-file-1740639955183.jpeg',
      descriptions: [
        'The importance of ESG assurance and third-party audits.',
        'How to conduct an ESG audit and prepare for external assessments.',
        'Addressing gaps and improving ESG scores.'
      ]
    },
    {
      title: 'The Future of ESG: Innovations and Emerging Trends',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/cc4c2424da8c515798c73dcdf9f69eb5bf0e2fe2acc149a25ee49f42574cadd7beb1337f849d40be4fd447cccd7df32b92adf4475d9297e9fce201dbe273bd79a43a71a5fa576dcf769c020eccb43811a4a53e8f54aff2c9989fb4c4df243095856e3095913f644460dcd3ab6514a64ca3f431539f0525b2dce6/rez-file-1740640001968.png',
      descriptions: [
        'AI, blockchain, and technology-driven ESG solutions.',
        'The evolving regulatory landscape and corporate sustainability.',
        'How companies can stay ahead in their ESG journey.'
      ]
    },
  ]

  return (
    <div>
      <section>
        <div className='relative'>
          <img src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/25708212d8c5e137294fe7ba0ad7baae4ce269c444086d80c0cdc85e602a4f8e5184556e4a039c3d9b54f528894634179c4925716df56a1400eb9db3ef2ebed69675bd481f55d5c33cec7892e2dd4b7f0d3025a58549e877d0a6b4d6afb885378ef627df505e501bc008c01cfca3a2046fd1ecd43c1afcacd8a4/rez-file-1739775349512.jpg" alt="main" className='w-full max-h-40 sm:max-h-80 object-cover object-bottom' />
          <div className='absolute top-0 bottom-0 left-0 right-0 bg-app-orange/10 text-white'>
            <div className='app-main-container flex flex-col justify-center items-center h-full gap-4 sm:gap-8'>
              <p className='text-xl/[2rem] sm:text-3xl/[4rem] lg:text-5xl/[5rem] max-w-6xl px-8 font-semibold sm:font-bold text-center app-animation-translate-start leading-8'>ESG Workshop & Inhouse Training Topics</p>
            </div>
          </div>
        </div>
      </section>

      <section className='bg-app-dark-gray/10'>
        <div className='app-main-container space-y-8'>
          <p className='py-3 md:py-6 text-base/[1.75rem] md:text-lg/[2rem] xl:text-xl/[2.5rem] text-center app-animation-translate-start'>
            Our <b>ESG (Environmental, Social, and Governance) Workshops & In-House Training</b> programs are designed to help organizations, businesses, and educational institutions integrate <b>sustainability, ethical leadership, and responsible governance</b> into their operations. Delivered by industry experts, our sessions provide <b>practical insights, real-world case studies, and actionable strategies</b> to enhance ESG performance and compliance.
          </p>
        </div>
      </section>

      <section className='bg-app-light-gray/10'>
        <div className='app-main-container space-y-8 pb-10 md:pb-14'>
          <p className='pt-3 pb-2 md:pt-6 md:pb-4 text-xl md:text-2xl xl:text-4xl font-bold text-app-orange text-center app-animation-translate-start'>
            ESG Workshop & Inhouse Training Topics
          </p>
          <div className='grid grid-cols-1 gap-10 md:gap-14 pt-2 pb-6 md:pt-4 md:pb-12'>
            {esg_contents.map((content, i) => {
              return (
                <div key={i} className='flex flex-row-reverse bg-app-dark-gray/10 rounded-lg app-animation-translate-start'>
                  <img className="w-1/2 aspect-video object-center object-cover rounded-r-lg" src={content.img_url} alt={content.title} />
                  <Accordion className='w-1/2 p-4 flex items-center' transition transitionTimeout={200}>
                    <AccordionItem header={content.title} key={i} order={i}>
                      <ul className='mt-2 ml-3 sm:ml-6 flex flex-col items-start text-sm sm:text-base md:text-lg xl:text-xl space-y-2'>
                        {content.descriptions.map((description, k) => {
                          return (
                            <li key={k} className='px-2 list-disc'>
                              {description}
                            </li>
                          )
                        })}
                      </ul>
                    </AccordionItem>
                  </Accordion>
                </div>
              )
            })}
          </div>
          <div className='bg-app-dark-gray/10 space-y-4 p-4 sm:p-6 rounded-lg app-animation-translate-start'>
            <p className='font-bold text-base sm:text-lg xl:text-xl'>Duration, Content, Format, Audience:</p>
            <p className='text-sm sm:text-base xl:text-lg'>Can be customised based on the Clients’ needs and Global/National ESG related regulations/standards development.</p>
          </div>
        </div>
      </section>
    </div>
  )
}

export default ESGWorkshopTraining